import { CustomAlert } from '@/components/shared/components/CustomAlert';

export const NoConditionsAvailable = () => {
  return (
    <CustomAlert
      title={'NO_CONDITIONS_AVAILABLE'}
      description={'NO_CONDITIONS_AVAILABLE_DESCRIPTION'}
      severity="warning"
    />
  );
};
